import React from 'react';

import { IconFacebook, IconInstagram, IconTiktok, IconTwitter, IconYoutube } from './icons';
import { SocialIcon } from './social-icon';
import { SocialIconsContainer } from './styled';
import { ISocialCompProps, ISocialIconsProps } from './types';

const socialComponents = {
  facebookUrl: IconFacebook,
  instagramUrl: IconInstagram,
  tiktokUrl: IconTiktok,
  twitterUrl: IconTwitter,
  youtubeUrl: IconYoutube,
};

export const SocialComp: React.FC<ISocialCompProps> = props => {
  const SocialComponent = socialComponents[props.item];
  return (
    <SocialIcon href={props.href}>
      <SocialComponent width={25} aria-hidden="true" />
    </SocialIcon>
  );
};
export const SocialIcons: React.FC<ISocialIconsProps> = props => {
  return (
    <SocialIconsContainer>
      {Object.keys(props).map((item, i) => {
        if (!props[item] || props[item] === '') {
          return null;
        }
        return <SocialComp key={`social_${i}`} item={item} href={props[item]} />;
      })}
    </SocialIconsContainer>
  );
};
